import React from "react"

import {
  radioButtonContainer,
  radioWrapper,
  radioButtonStyle,
  labelContainerStyle,
  errorMessage,
} from "./RadioButton.css"

type RadioButtonType = {
  name: string
  value: string
  checked: boolean
  isDisabled?: boolean
  error?: {
    message: string
  }
  wrapperStyle?: "border" | "background"
  children: React.ReactNode
  onChange: (value: string) => void
}

const getRadioStyleType = (
  checked: boolean,
  error: { message: string } | undefined,
  isDisabled: boolean
) => {
  if (isDisabled) {
    return checked ? "disabledChecked" : "disabled"
  }
  if (error?.message) {
    return checked ? "errorChecked" : "error"
  }
  if (checked) {
    return "checked"
  }
  return "default"
}

export const RadioButton: React.FC<RadioButtonType> = ({
  name,
  value,
  checked = false,
  isDisabled = false,
  error,
  children,
  wrapperStyle = "default",
  onChange,
}) => {
  const radioStyleType = getRadioStyleType(checked, error, isDisabled)
  const labelStyleType = isDisabled ? "disabled" : "default"

  return (
    <div className={radioButtonContainer}>
      <div className={radioWrapper[wrapperStyle]} key={value}>
        <input
          name={name}
          data-testid={`radio-${value}`}
          className={radioButtonStyle[radioStyleType]}
          type="radio"
          onChange={(e) => onChange(e.target.value)}
          disabled={isDisabled}
          value={value}
          checked={checked}
          id={`${name}-${value}`}
        />
        <label
          className={labelContainerStyle[labelStyleType]}
          htmlFor={`${name}-${value}`}
        >
          {children}
        </label>
      </div>
      {error?.message && <span className={errorMessage}>{error.message}</span>}
    </div>
  )
}
